__turbopack_context__.v({
  "modalData": "PrimaryOffers-module__qY5pIW__modalData",
  "primaryOffers": "PrimaryOffers-module__qY5pIW__primaryOffers",
  "transitionTile": "PrimaryOffers-module__qY5pIW__transitionTile",
});
